import { Box } from "@mui/material";
import type { KeyboardEvent } from "react";
import {
  tiptapTarget,
  toolbarMicSx,
  WithDictation,
} from "shared/features/voice-dictation";
import {
  ChatMessageEditor,
  type ChatMessageEditorHandle,
  type ChatMessageEditorProps,
} from "./ChatMessageEditor";

/**
 * While dictating, Escape does nothing. Without this the editor, which catches
 * Escape before its children, would cancel the whole edit under the box.
 */
const keepEscapeFromEdit = (event: KeyboardEvent) => {
  if (event.key === "Escape") event.stopPropagation();
};

/**
 * Editing a sent message, with voice dictation: the mic at the right end of
 * the toolbar, the dictation box over the editor and its Cancel / Save.
 */
export const ChatMessageEditorWithDictation = (
  props: ChatMessageEditorProps,
) => (
  <WithDictation<ChatMessageEditorHandle>
    toTarget={(handle) => tiptapTarget(handle?.getEditor())}
    disabled={props.isSaving}
    // The toolbar has no side padding here (`containerSx` px 0).
    micSx={toolbarMicSx("0px")}
    render={({ ref, endAdornment, overlay }) => (
      <Box onKeyDownCapture={overlay ? keepEscapeFromEdit : undefined}>
        <ChatMessageEditor
          {...props}
          endAdornment={endAdornment}
          overlay={overlay}
          editorRef={ref}
        />
      </Box>
    )}
  />
);
